import { IApplicationState } from '../../../shared/types/redux';
import { renderApplication } from '../renderApplication';
import { createContext } from './createContext';

export async function runApp() {
  const context = createContext();
  const { config } = context;

  const projectName = config.getStrict<string>('projectName');
  const initialState = config.getStrict<IApplicationState>('initialState');

  renderApplication({ initialState, projectName, context });
}
